/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type NonUserDefragEmailResponseType = "No" | "NotSure" | "Yes" | "%future added value";
export type UpsertNonUserDefragEmailResponseInput = {
    additionalInformation?: string | null | undefined;
    clientMutationId?: string | null | undefined;
    emailInstanceId: string;
    responseType: NonUserDefragEmailResponseType;
};
export type UpsertNonUserDefragEmailResponseMutationVariables = {
    input: UpsertNonUserDefragEmailResponseInput;
};
export type UpsertNonUserDefragEmailResponseMutationResponse = {
    readonly upsertNonUserDefragEmailResponse: {
        readonly nonUserDefragEmailResponse: {
            readonly id: string;
            readonly responseType: NonUserDefragEmailResponseType;
            readonly additionalInformation: string | null;
        } | null;
    } | null;
};
export type UpsertNonUserDefragEmailResponseMutation = {
    readonly response: UpsertNonUserDefragEmailResponseMutationResponse;
    readonly variables: UpsertNonUserDefragEmailResponseMutationVariables;
};



/*
mutation UpsertNonUserDefragEmailResponseMutation(
  $input: UpsertNonUserDefragEmailResponseInput!
) {
  upsertNonUserDefragEmailResponse(input: $input) {
    nonUserDefragEmailResponse {
      id
      responseType
      additionalInformation
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "UpsertNonUserDefragEmailResponsePayload",
            "kind": "LinkedField",
            "name": "upsertNonUserDefragEmailResponse",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "NonUserDefragEmailResponse",
                    "kind": "LinkedField",
                    "name": "nonUserDefragEmailResponse",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "id",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "responseType",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "additionalInformation",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "UpsertNonUserDefragEmailResponseMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "UpsertNonUserDefragEmailResponseMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "b478bd85f38ebf5c978a27bc160c8af6",
            "id": null,
            "metadata": {},
            "name": "UpsertNonUserDefragEmailResponseMutation",
            "operationKind": "mutation",
            "text": "mutation UpsertNonUserDefragEmailResponseMutation(\n  $input: UpsertNonUserDefragEmailResponseInput!\n) {\n  upsertNonUserDefragEmailResponse(input: $input) {\n    nonUserDefragEmailResponse {\n      id\n      responseType\n      additionalInformation\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = 'a53deb4da8ddbbf9ffd017fe66a6cc38';
export default node;
